import DataTable from 'react-data-table-component';
import { translate } from 'react-switch-lang';

const NatureProductColumns = (props) => {
  const natureProductColumns: any = [
    {
      name: props.t('list_np'),
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    // {
    //   name: props.t('status'),
    //   selector: row => row.status,
    //   sortable: false,
    //   center: true,
    // },
    {
      id: 'Action',
      name: props.t('actions'),
      selector: (row) => row.action,
      sortable: false,
      center: true,
    },
  ];
  return <DataTable columns={natureProductColumns} data={props.data} />;
};

export default translate(NatureProductColumns);
